const getters = {
  token: (state) => state.user.token,
  permissions: (state) => state.user.permissions,
  priceViewPermission: (state) => state.user.priceViewPermission,
  userData: (state) => state.user.userData,
  mainBodyType: (state) => state.user.mainBodyType,
  userInfo: (state) => state.user.userInfo,
  // standardType: (state) => state.user.standardType,
};
export default getters;
